module.exports = __webpack_public_path__ + "img/56.6.CODm.731d33fd.png";